/* eslint-disable no-case-declarations */
import {
  DELETE_AUTH_OFFER_HISTORY_LIST_SUCCESS,
  GET_AUTH_DESTINATION_SERVICES_SUCCESS,
  GET_AUTH_OFFER_HISTORY_LIST_SUCCESS,
  POST_AUTH_OFFER_HISTORY_LIST_SUCCESS,
  UPDATE_AUTH_DESTINATION_SERVICES_BUYER_SUCCESS,
  UPDATE_AUTH_DESTINATION_SERVICES_RENTER_SUCCESS,
  UPDATE_AUTH_OFFER_HISTORY_LIST_SUCCESS,
  GET_AUTH_DESTINATION_ESTIMATED_DATES_SUCCESS,
  UPDATE_AUTH_DESTINATION_ESTIMATED_DATES_SUCCESS
} from '../types/destinationServiceTypes';

const handleDestinationService = (draft, action) => {
  if (!draft.authorizationDetails[draft.currentAuthId]) draft.authorizationDetails[draft.currentAuthId] = {};
  if (draft.currentAuthId && !draft.authorizationDetails[draft.currentAuthId].destinationServices)
    draft.authorizationDetails[draft.currentAuthId].destinationServices = {};

  switch (action.type) {
    case GET_AUTH_DESTINATION_SERVICES_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].destinationServices = action.response;
      draft.authorizationDetails[draft.currentAuthId].destinationServices.destinationBuyerInfo = action.response.destinationBuyerInfo;
      draft.authorizationDetails[draft.currentAuthId].destinationServices.destinationRenterInfo = action.response.destinationRenterInfo;
      break;

    case UPDATE_AUTH_DESTINATION_SERVICES_BUYER_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].destinationServices.destinationBuyerInfo = action.response;
      break;

    case GET_AUTH_OFFER_HISTORY_LIST_SUCCESS:
    case POST_AUTH_OFFER_HISTORY_LIST_SUCCESS:
    case UPDATE_AUTH_OFFER_HISTORY_LIST_SUCCESS:
    case DELETE_AUTH_OFFER_HISTORY_LIST_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].destinationServices.destinationOfferHistoryInfo = action.response;
      break;

    case UPDATE_AUTH_DESTINATION_SERVICES_RENTER_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].destinationServices.destinationRenterInfo = action.response;
      break;

    case GET_AUTH_DESTINATION_ESTIMATED_DATES_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].destinationServices.destinationEstimatedDates = action.response;
      break;

    case UPDATE_AUTH_DESTINATION_ESTIMATED_DATES_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].destinationServices.destinationEstimatedDates = action.response;
      break;

    default:
      break;
  }

  return draft;
};

export default handleDestinationService;
